import {Injectable} from '@angular/core';
import {UtilityService} from '@irb/irb-common/services/utility.service';
import {IDropdownItem} from "@irb-common/models/dropdown.model";

@Injectable({providedIn: 'root'})
export class SacSecurityTypeService {
    sacSecurityTypes: Array<IDropdownItem> = [
        {name: "Alternative Investments", value: "Alternative Investments"},
        {name: "Cash", value: "Cash"},
        {name: "ETF", value: "ETF"},
        {name: "Equity", value: "Equity"},
        {name: "External", value: "External"},
        {name: "Fixed Income", value: "Fixed Income"},
        {name: "Group", value: "Group"},
        {name: "Mutual Fund", value: "Mutual Fund"},
        {name: "Option", value: "Option"},
        {name: "Other", value: "Other"},
        {name: "SMA", value: "SMA"}
    ];

    constructor(private util: UtilityService) {
        this.sacSecurityTypes = this.util.sortByKey(this.sacSecurityTypes, 'name', 'asc');
    }

    getDropdownOptionsForSacSecurityTypes() {
        return this.sacSecurityTypes;
    }
}
